module.exports = __webpack_public_path__ + "img/banner-img.04900563.png";